import { render, staticRenderFns } from "./BorrowerDetailModal.vue?vue&type=template&id=18e44d9a&scoped=true"
import script from "./BorrowerDetailModal.vue?vue&type=script&lang=js"
export * from "./BorrowerDetailModal.vue?vue&type=script&lang=js"
import style0 from "./BorrowerDetailModal.vue?vue&type=style&index=0&id=18e44d9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e44d9a",
  null
  
)

export default component.exports